// API Configuration
const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000',
  ENDPOINTS: {
    // Authentication endpoints
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    VERIFY_TOKEN: '/api/auth/verify',
    
    // Employee endpoints
    EMPLOYEES: '/api/employees',
    EMPLOYEES_DETAILS: '/api/employees/details',
    EMPLOYEE_BY_ID: (empId) => `/api/employee/${empId}`,
    EMPLOYEE_GOODIES: (empId) => `/api/employee/${empId}/goodies`,
    EMPLOYEE_GOODIES_RETURN: (empId) => `/api/employees/${empId}/goodies/return`,
    EMPLOYEE_GOODIES_COMPLETE: (empId) => `/api/employee/${empId}/goodies`,
    EMPLOYEE_PRINT: (empId) => `/api/employees/${empId}/print`,
    EMPLOYEE_SEARCH: '/api/dashboard',
    
    // Goodies endpoints
    GOODIES: '/api/goodies',
  },
  // Default values
  DEFAULTS: {
    EVENT_WEBSITE: 'https://indiaexchange.presidio.com'
  }
};

// Helper function to build full URL
const buildUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Export individual endpoints for easy use
export const API_ENDPOINTS = {
  LOGIN: buildUrl(API_CONFIG.ENDPOINTS.LOGIN),
  LOGOUT: buildUrl(API_CONFIG.ENDPOINTS.LOGOUT),
  VERIFY_TOKEN: buildUrl(API_CONFIG.ENDPOINTS.VERIFY_TOKEN),
  EMPLOYEES: buildUrl(API_CONFIG.ENDPOINTS.EMPLOYEES),
  EMPLOYEES_DETAILS: buildUrl(API_CONFIG.ENDPOINTS.EMPLOYEES_DETAILS),
  EMPLOYEE_BY_ID: (empId) => buildUrl(API_CONFIG.ENDPOINTS.EMPLOYEE_BY_ID(empId)),
  EMPLOYEE_GOODIES: (empId) => buildUrl(API_CONFIG.ENDPOINTS.EMPLOYEE_GOODIES(empId)),
  EMPLOYEE_GOODIES_RETURN: (empId) => buildUrl(API_CONFIG.ENDPOINTS.EMPLOYEE_GOODIES_RETURN(empId)),
  EMPLOYEE_GOODIES_COMPLETE: (empId) => buildUrl(API_CONFIG.ENDPOINTS.EMPLOYEE_GOODIES_COMPLETE(empId)),
  EMPLOYEE_PRINT: (empId) => buildUrl(API_CONFIG.ENDPOINTS.EMPLOYEE_PRINT(empId)),
  EMPLOYEE_SEARCH: buildUrl(API_CONFIG.ENDPOINTS.EMPLOYEE_SEARCH),
  GOODIES: buildUrl(API_CONFIG.ENDPOINTS.GOODIES),
};

// Export defaults
export const API_DEFAULTS = API_CONFIG.DEFAULTS;

// Export base URL for any custom endpoints
export const API_BASE_URL = API_CONFIG.BASE_URL;

export default API_ENDPOINTS;
